/********************************************************************************
 * @author       Tech.us
 * @module       AuthModule
 * @name         ResetPassword
 * @description  Component for resetting the password
 * @copyright    Tech.us
 * @Createdon    Apr 2025 
 * @since        1.0
 *********************************************************************************/

import React, { useState, useEffect, useRef } from "react";
import {useNavigate, Navigate, useLocation } from "react-router-dom";
import leftImg from '../../assets/Images/backgruonds/login-left-bg-wt.png'
import CONFIG from "../../config/config";
import { ForgotPasswordTokenCheck,PasswordReset } from '../../services/techus-services'
import { showToast } from '../../genriccomponents/techus-ToastNotification.js';
import { HamrickPrecastLogo } from '../../assets/Images/logos'
import TinyWhiteLoader from "../../genriccomponents/loaders/TinyWhiteLoader.js";
const ResetPassword = (props) => {
	const [password, setPassword] = useState("");
	const [confirmPassword, setConfirmPassword] = useState("");
	const [formErrors, setFormErrors] = useState({});
	const errors = {};
	const search = useLocation().search;
	const token = new URLSearchParams(search).get('token');
	const [showField, setShowField] = useState(true);
	const [errMsg, setErrMsg] = useState("");
	const [succMsg, setSuccMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);

	const [passwordEye, setPasswordEye] = useState(false);
	const passwordTextShow = useRef();
	const newPasswordTextShow = useRef();
	const [passwordType, setPasswordType] = useState('password')
	const [confPassword, setConfPassword] = useState('password')
 const navigate = useNavigate()

 useEffect(() => {
  const fetchData = async () => {
    const formData = {
      password_token: token,
    };
    const response = await ForgotPasswordTokenCheck(formData);

    if (!response?.valid) {
      showToast('error', response.message);
    } else {
      return true;
      // showToast('success', response.message);
    }
  };

  fetchData();
}, []);


	const isLogged = !!localStorage.getItem('isAuthenticated');

	if (isLogged) {
		localStorage.removeItem("token");
    localStorage.clear();
	};


	// password eye icon code
	const passwordView = (text, newText) => {
		if (text !== ''|| newText !== '') {
			setPasswordEye(true);
		} else {
			setPasswordEye(false);
		}
	}
	const showPassword = (e) => {
		e.preventDefault();
		if (passwordTextShow.current.type === 'password') {
			passwordTextShow.current.setAttribute('type', 'text')
			setPasswordType('text')
			
		} else {
			passwordTextShow.current.setAttribute('type', 'password')
			setPasswordType('password')
			
		}
	}

	const showNewPassword = (e) => {
		e.preventDefault();
		if(newPasswordTextShow.current.type === 'password'){
			newPasswordTextShow.current.setAttribute('type', 'text');
			setConfPassword('text')
		}else{
			newPasswordTextShow.current.setAttribute('type', 'password')
			setConfPassword('password')
		}
	}
	
	useEffect(() => {
		passwordView(password, confirmPassword);
	}, [password, confirmPassword])

	const runValidations = () => {
		//password
		const specialCharacters = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
		if (password.trim().length === 0) {
			errors.password = "Password is required";
		} else if (password.trim().length < 8) {
			errors.password = " Password must contain more than 8 characters.";
		} else if (password.trim().length > 26) {
			errors.password = " Password must contain less than 25 characters.";
		}
		else if (!/[A-Z]/.test(password)) {
			errors.password = "Password must contain at least one uppercase letter.";
		} 
		else if (!/[a-z]/.test(password)) {
			errors.password = "Password must contain at least one lowercase letter.";
		} 
		else if (password.trim().search(/[0-9]/) < 0) {
			errors.password = " Password must contain at least one number.";
		}
		else if (!specialCharacters.test(password)) {
			errors.password = " Password must contain at least one special character.";
		}


		if (confirmPassword.trim().length === 0) {
			errors.confirmPassword = "Confirm password is required";
		}
		else if (password.trim() !== confirmPassword.trim()) {
			errors.confirmPassword = "Password and Confirm password should be same.";
		}

		// setTimeout(() => { setFormErrors({}) }, 8000);
	};



  const handleSubmit = async (e) => {
    e.preventDefault();
    runValidations();
    if (Object.keys(errors).length === 0) {
      setFormErrors({});
      setIsLoading(true);
      const formData = {
        password,
        password_token: token,
      };
  
      try {
        const response = await PasswordReset(formData);
  
        if (!response?.valid) {
          setIsLoading(false)
          showToast('error', response.message);
        } else {
          setIsLoading(false)
          showToast('success', response.message);
          setConfirmPassword('');
          setPassword('');
          window.localStorage.removeItem('token');
          setTimeout(() => {
            navigate('/login');
          }, 4000);
        }
      } catch (error) {
        showToast('error', 'An error occurred. Please try again.');
        console.error('Error resetting password:', error);
      } finally {
        setIsLoading(false)
      }
    } else {
      setFormErrors(errors);
    }
  };

	const handleChange = (e) => {
		if (e.target.name === "confirm_password") {
			setConfirmPassword(e.target.value);
		} else if (e.target.name === "password") {
			setPassword(e.target.value);
		}
		setFormErrors({})
	};

	const hideMsg = () => {
		setErrMsg('');
		setSuccMsg('');
	};

  const d = new Date();
	let year = d.getFullYear();


	return (
		<main className="login-wrapper">
			<div className="container-fluid">
				<div className="row">

        <div className='col-lg-6 col-sm-12 login-letf'>
          <div className='left-bottom-box'>
            <p className='left-header-text animate__animated animate__bounceInLeft '>
              WHP AI  <br />
              Quoting Tool
            </p>
            <p className='text-white text-25 animate__animated animate__zoomIn animate__delay-1s '>An AI powered tool that converts your <br /> plans to submittals.</p>

          </div>
        </div>

  <div className='col-lg-6 position-relative  col-sm-12 d-dlex justify-content-center align-item-center  '>
          <div className='d-flex align-item-center justify-content-center '>
            <img className='login-right-logo animate__animated animate__slideInRight' src={HamrickPrecastLogo} alt="Hamrick Precast" />

          </div>
            <div className=' animate__animated animate__slideInRight mb-3' >
              <div className='text-center margin-top-30 '>
                <p className='text-30 text-bold-800'>Reset Password</p>
                <p className='text-16 color-light-grey'>Your new password must contain: 
  <br/><br/>
At least 8 characters;  At least 1 capital letter;  At least 1 <br/> number;  At least 1 special character.</p>
              </div>
              <div className='d-flex justify-content-center margin-top-23'>
                <div className="login-input-container"> 
                  <form onSubmit={handleSubmit} noValidate className="form-group">

                    <div className=' '>
                    <span className='text-14 text-bold-700 '>New Password <span className='red-color'>*</span></span>
                        <label className="label">
                          <input
                             tabIndex='1' className="input" type="password"
                            placeholder="Enter New Password"
                            id="password"
                            ref={passwordTextShow}	
                            value={password}
                            onChange={handleChange}
                            autoComplete="off" name="password"
                          />
                          <i onClick={showPassword} className={passwordType !== "password" ? "icon-view people-login-icon cursor-pointer" : "cursor-pointer icon-hide people-login-icon"}></i>
                          <span className="input-border"></span>
                        </label>
                        {formErrors.password && (
                          <span className="login-error"> {formErrors.password} </span>
                        )}
                      <div className='pass-box-reset'>
                        <span className='text-14 text-bold-700 '>Confirm Password <span className='red-color'>*</span></span>
                        <label className="label">

                          <input
                            tabIndex='2' className="input"
                            
                            placeholder="Enter Confirm Password"
                            type="password" id="confirm_password"
                            ref={newPasswordTextShow}
                            value={confirmPassword}
                            onChange={handleChange}
                            autoComplete="off" name="confirm_password"
                          />
                          <i onClick={showNewPassword} className={confPassword !== "password" ? "icon-view people-login-icon cursor-pointer" : "cursor-pointer icon-hide people-login-icon"}></i>
                          <span className="input-border"></span>
                        </label>
                        {formErrors.confirmPassword && (
                          <span className="login-error position-fixed"> {formErrors.confirmPassword} </span>
                        )}
                        <div className="submit mt-2">
                          {isLoading ?
                            <button className={' button2'} disabled={isLoading}>{<TinyWhiteLoader />} </button>
                            :
                            <button className={' button2'} disabled={isLoading}><span className='my-1'>Reset Password</span>  </button>
                          }
                        </div>
                      </div>
                      
                    </div>
                    
                  </form>

                </div>
              </div>
            </div>
            <p className='text-16 text-center color-light-grey  mt-1 mb-5'>For the security of your account, once you set your new password, <br/> you will be logged out of any other devices.</p>

          <div className='fixed-bottom text-center position-absolute'><p className='text-13 color-dark-grey'>© Copyright 2024. All Rights Reserved</p></div>
        </div>
				</div>
			</div>
		</main>
	);
};

export default ResetPassword;
